import React from "react";
import "./Footer.css";

export const Footer = props => {
    return (<div className={"defaultFooter"}>
        <a href="/privacy">Privacy</a> | <a href="/impressum">Impressum</a> | <a href={props.link_copyright}>{props.text}</a> | <a href={props.link_version}>{props.version}</a>
    </div>);
}

export default Footer;